/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Vaccination from './vaccination';
import VaccinationDetail from './vaccination-detail';
import VaccinationUpdate from './vaccination-update';
import VaccinationDeleteDialog from './vaccination-delete-dialog';

const VaccinationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Vaccination />} />
    <Route path="new" element={<VaccinationUpdate />} />
    <Route path=":id">
      <Route index element={<VaccinationDetail />} />
      <Route path="edit" element={<VaccinationUpdate />} />
      <Route path="delete" element={<VaccinationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default VaccinationRoutes;
